import { useContext, useEffect, useState } from "react";
import ClientNavbar from "../layout/ClientNavbar";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import locContext from "../context/locContext";
import { NavLink } from "react-router-dom";

export default function ClientLoan() {
  const navigate = useNavigate();

  const { userData } = useContext(locContext);
  const id = userData?.id || null;

  const [data, setData] = useState([]);

  const getLoanApplicationData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_BASE_URL}/loan-application/user/${id}`,
      );
      if (res.status === 200) {
        setData(res.data.data.slice(0, 5));
      } else {
        setData([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    getLoanApplicationData();
  }, []);

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
          {/* Loan Application Section */}
          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Apply For Loan</h3>
            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Apply For Loan
                </li>
              </ol>
            </nav>

            <div className="d-flex gap-2 flex-wrap">
              <button
                className="btn btn-primary"
                onClick={() => navigate("/loanapplication")}
              >
                Loan Application
              </button>
            </div>
          </div>

          {/* Recent Loan Applications Table */}
          <div className="card shadow-sm p-4 mb-4">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3">
              <h4 className="fw-bold mb-0">Recent Loan Applications</h4>
              {/* Navigate to Total Applications page */}
              <Link
                className="btn btn-primary"
                to="/totalapplication"
                onClick={() => window.scrollTo({ top: 0, behavior: "instant" })}
              >
                View All
              </Link>
            </div>

            <div className="table-responsive">
              <table className="table table-bordered align-middle text-center">
                <thead style={{ backgroundColor: "#FFE6DC" }}>
                  <tr>
                    <th>Application No.</th>
                    <th>Loan Type</th>
                    <th>Application Date</th>
                    <th>Loan Amount</th>
                    <th>Market Value</th>
                    <th>Phone</th>
                    <th>PAN</th>
                    <th>Category</th>
                    <th>Type</th>
                    <th>Profession</th>
                    <th>Industry</th>
                  </tr>
                </thead>
                {/* <tbody>
                  {data.map((app, index) => (
                    <tr key={index} style={{ whiteSpace: "nowrap" }}>
                      <td className="text-primary fw-semibold">
                        {app.application_code}
                      </td>
                      <td>{app.loan_type}</td>
                      <td>{app.application_date.split("T")[0]}</td>
                      <td>
                        {Number(app.loan_amount).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}
                      </td>
                      <td>
                        {Number(app.market_value).toLocaleString("en-IN", {
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}
                      </td>

                      <td>{app.user_phone || "-"}</td>
                      <td>{app.user_pan || "-"}</td>
                      <td>{app.loan_category || "-"}</td>
                      <td>{app.loan_type || "-"}</td>
                      <td>{app.profession || "-"}</td>
                      <td>{app.industry || "-"}</td>

                    
                    </tr>
                  ))}
                </tbody> */}

                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td
                        colSpan={11}
                        className="text-center py-4 text-muted fw-semibold"
                      >
                        No data available
                      </td>
                    </tr>
                  ) : (
                    data.map((app, index) => (
                      <tr key={index} style={{ whiteSpace: "nowrap" }}>
                        <td className="text-primary fw-semibold">
                          {app.application_code}
                        </td>
                        <td>{app.loan_type}</td>
                        <td>{app.application_date.split("T")[0]}</td>
                        <td>
                          {Number(app.loan_amount).toLocaleString("en-IN", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>
                          {Number(app.market_value).toLocaleString("en-IN", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                        <td>{app.user_phone || "-"}</td>
                        <td>{app.user_pan || "-"}</td>
                        <td>{app.loan_category || "-"}</td>
                        <td>{app.loan_type || "-"}</td>
                        <td>{app.profession || "-"}</td>
                        <td>{app.industry || "-"}</td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Dashboard Cards */}
          <div className="card shadow-sm p-4 mb-4">
            {/* <h3 className="text-primary mb-4">Dashboard</h3> */}
            <div className="row g-3">
              <div className="col-md-4">
                <Link
                  to="/totalapplication"
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                >
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Total Application</h5>
                    <h6 className="text-primary">0</h6>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <Link
                  to="/incometaxdetails"
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                >
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Income Tax Details</h5>
                    <h6 className="text-primary">0</h6>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <Link
                  to="/gstdetails"
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                >
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">GST Details</h5>
                    <h6 className="text-primary">0</h6>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <Link
                  to="/bankinganalytics"
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                >
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Banking Analytics</h5>
                    <h6 className="text-primary">0</h6>
                  </div>
                </Link>
              </div>

              <div className="col-md-4">
                <Link
                  to="/bankinganalytics"
                  className="text-decoration-none text-dark"
                  onClick={() =>
                    window.scrollTo({ top: 0, behavior: "instant" })
                  }
                >
                  <div className="card text-center bg-light p-3 h-100">
                    <h5 className="text-teal mb-1">Loan Amount</h5>
                    <h6 className="text-primary">₹0</h6>
                  </div>
                </Link>
              </div>
            </div>
          </div>

          {/* Quick Actions Section */}
          {/* <div className="card shadow-sm p-4">
            <h5 className="mb-3">Quick Actions</h5>
            <div className="d-flex gap-2 flex-wrap">
              <button
                className="btn btn-primary"
                onClick={() => navigate("/mutual-funds")}
              >
                Explore Mutual Funds
              </button>
              <button
                className="btn btn-primary"
                onClick={() => navigate("/start-investment")}
              >
                Start New Investment
              </button>
            </div>
          </div> */}
        </div>
     
    </>
  );
}
